import React from 'react';
import { DropTarget } from 'react-dnd';
import { FormattedDate } from 'react-intl';
import DndProduct from './DndProduct';
import ShipmentBadgeComponent from './ShipmentBadgeComponent';
import { Card, CardBody, Col, Label, Row,CardHeader } from 'reactstrap';
import { GoogleMapsLink } from '@ami/react/core';

const cardTarget = {
  drop(props, monitor) {
    const product = monitor.getItem();
    const { shipment } = props;
    if (product.shipmentId !== shipment.id) {
      props.moveProduct(product.id, shipment.id);
    }
  },
};

export const DndShipment = ({
  isOver,
  canDrop,
  connectDropTarget,
  shipment,
  order,
  productConfiguration,
  onSelect,
  onRemove,
  loadOrder
}) => {
  const isActive = isOver && canDrop;
  const backgroundColor = isActive && canDrop ? '#ccc' : '#fff';
  const products = order.lineItems.filter((x) => x.shipmentId === shipment.id);
  return connectDropTarget(
    <div>
      <Card>
      <CardHeader>
      <div className="flextable">
          <div className="flextable-item flextable-primary">
            <Label>{shipment.name}</Label>
          </div>
        </div>
        <Row className="mt-1">
          <Col>
            <h5>
              {shipment.shipmentDate ? (
                <FormattedDate
                  value={shipment.shipmentDate}
                  year="numeric"
                  month="long"
                  day="2-digit"
                  timeZone="utc"
                />
              ) : (
                'SELECT DATE'
              )}
            </h5>
            <ShipmentBadgeComponent shipment={shipment} />
            <button className="btn btn-link pt-0" onClick={() => onSelect()}>
               edit shipment
            </button>
            {products.length === 0 && (
              <button
                className="btn btn-danger pull-right"
                onClick={() => onRemove()}
              >
                remove
              </button>
            )}
          </Col>
        </Row>
        <Row className="mt-1">
        <Col>
        {shipment.customLocation && (
              <Label >
                  <GoogleMapsLink  location={shipment.customLocation} />
                  </Label>
                )}
            {!shipment.customLocation && order.dealerInformation && (
              <div className='row'>
                <div className='col-12'>{ `Dealer Branch (${order.dealerInformation.dealerBranchName})`}</div>
                <div className='col-12'>{order.dealerInformation.dealerBranchAddress}</div>
              </div>
            )}
        </Col>
        </Row>
        { shipment.customInstruction && (
          <Row className="mt-1">
          <Col>
          <Label>{shipment.customInstruction}</Label>
          </Col>
          </Row>)
        }
      </CardHeader>
      <CardBody className="p-3 line-items">
      {products.map((product, i) => (
          <div key={i} >
            <DndProduct
              product={product}
              productConfiguration={productConfiguration}
              order={order}
              loadOrder={loadOrder}
            />
          </div>
        ))}
      </CardBody>
    </Card>

    </div>
  );
};

export default DropTarget(
  'dndShipmentProducts',
  cardTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  })
)(DndShipment);
